import { isNil } from "lodash";

import { Precision } from "../../../../types";
import calendarTypes from "../../../../types/calendarTypes";

const isPrecisionLegalForCalendarType = (calendarType, precision) => {
  switch (calendarType) {
    case calendarTypes.CALENDAR_TYPE_WEEKDAY_TIME:
      return precision >= Precision.Week;
    case calendarTypes.CALENDAR_TYPE_DAY_TIME:
      return precision >= Precision.Day;
    case calendarTypes.CALENDAR_TYPE_HOUR_TIME:
      return precision >= Precision.Hour;
    default:
      return true;
  }
};

const precisionForCalendarTypeAndDate = (calendarType, date) => {
  let minPrecision = Precision.Year;
  switch (calendarType) {
    case calendarTypes.CALENDAR_TYPE_WEEKDAY_TIME:
      minPrecision = date.weekday === 0 ? Precision.Week : Precision.Day;
      break;
    case calendarTypes.CALENDAR_TYPE_DAY_TIME:
      minPrecision = Precision.Day;
      break;
    case calendarTypes.CALENDAR_TYPE_HOUR_TIME:
      minPrecision = Precision.Hour;
      break;
    default:
      break;
  }
  return Math.max(date.precision, minPrecision);
};

export default (start, calendar) => {
  if (isNil(start.timestamp) || isPrecisionLegalForCalendarType(calendar.calendarType, start.precision)) {
    return start;
  }
  const precision = precisionForCalendarTypeAndDate(calendar.calendarType, start);
  return start.set("precision", precision);
};
